// import firebase from 'firebase/app'
// import 'firebase/firebase-messaging'
// import 'firebase/firestore'
// import 'firebase/database'

import { CONFIG } from '../firebase_config'

// const firebaseApp = firebase.initializeApp(CONFIG)
// export const db = firebaseApp.database()

// src/firebase.js
import firebase from "firebase/app";
import "firebase/database";

firebase.initializeApp(CONFIG);

// Export database instance
const db = firebase.database();
export { db };